module.exports = __webpack_public_path__ + "img/loading.2f664a30.svg";